import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "b-plan-table__add_an_appointment" }
const _hoisted_2 = { class: "h-mr-3" }
const _hoisted_3 = { class: "h-mr-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fristHalfTime)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "b-plan-table__add_an_appointment__item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentHalf(_ctx.fristHalfTime)))
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.fristHalfTime), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.secondHalfTime)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "b-plan-table__add_an_appointment__item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentHalf(_ctx.secondHalfTime)))
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.secondHalfTime), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}